import * as LoginUtils from '../lib/LoginUtils';
import http from 'hub-http/clients/noAuthApiClient';
import TwoFactorAuthLevels from '../constants/TwoFactorAuthLevels';
import { OUTLOOK365 } from '../constants/LoginSources';
class TwoFactorLoginDao {
  tryTwoFactor(credentials) {
    const source = LoginUtils.getLoginSource();
    if (source === OUTLOOK365) {
      credentials.rememberLogin = true;
    }
    return http.post('/login-api/v1/login/verification-code', {
      data: credentials
    });
  }
  tryTwoFactorBackupCode(credentials) {
    const source = LoginUtils.getLoginSource();
    if (source === OUTLOOK365) {
      credentials.rememberLogin = true;
    }
    return http.post('/login-api/v1/login/verification-code', {
      data: credentials
    });
  }
  challengeTwoFactor(token, isPrimaryMethod) {
    const data = {
      token,
      twoFactorLevel: isPrimaryMethod ? TwoFactorAuthLevels.PRIMARY : TwoFactorAuthLevels.SECONDARY
    };
    return http.post('/login-api/v1/login/challenge-two-factor', {
      data
    });
  }
  resendTwoFactor(token, isPrimaryMethod) {
    const data = {
      token,
      twoFactorLevel: isPrimaryMethod ? TwoFactorAuthLevels.PRIMARY : TwoFactorAuthLevels.SECONDARY
    };
    return http.post('/two-factor/v1/challenge/new-code', {
      data
    });
  }
  requestTwoFactorCall(token, isPrimaryMethod) {
    const data = {
      token,
      twoFactorLevel: isPrimaryMethod ? TwoFactorAuthLevels.PRIMARY : TwoFactorAuthLevels.SECONDARY
    };
    return http.post('two-factor/v1/challenge/call', {
      data
    });
  }
  fetchHubspotAppStatus(twoFactorAuthToken) {
    return http.get(`/two-factor/v1/requests/poll/${twoFactorAuthToken}`);
  }
  loginWithHubspotApp(credentials) {
    const source = LoginUtils.getLoginSource();
    if (source === OUTLOOK365) {
      credentials.rememberLogin = true;
    }
    return http.post(`/login-api/v1/login/verification-code/approved-request`, {
      data: credentials
    });
  }
}
export default TwoFactorLoginDao;